import { DropdownOption, depascalize } from "sprint-common-web";

import { SprintEnum } from "../types/SprintEnum";

export const mapEnumToDropdownOptions = (theEnum: SprintEnum): DropdownOption[] =>
    Object.values(theEnum)
        .filter((v) => typeof v === "string")
        .map((keyName) => ({
            key: theEnum[keyName].toString(),
            text: keyName.toString()
        }));

export const mapEnumToDepascalizedDropdownOptions = (theEnum: SprintEnum): DropdownOption[] =>
    mapEnumToDropdownOptions(theEnum).map((option) => ({
        key: option.key,
        text: depascalize(option.text)
    }));
